import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import { isLoggedIn, updateSnackbar, fetchUser } from "../../actions";

class SecurityQuestion extends React.Component {
  constructor() {
    super();
    this.state = {
      question: "",
      answer: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitForm = (email, password) => ev => {
      ev.preventDefault();
      // TODO: Persist security questions
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.auth !== prevProps.auth) {
      if (this.props.auth.uid !== "init" && this.props.auth.uid !== "0") {
        this.props.fetchUser(this.props.auth.uid);
      }

      if (this.props.auth.security !== false) {
        this.props.history.push("/");
      }
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    console.log("[SECURITYQUESTION] RENDER");
    return (
      <Card style={{ width: "60%", maxWidth: "1100px", margin: "40px auto" }}>
        <CardContent style={{ padding: "0px" }}>
          <div style={{ padding: "40px" }}>
            <form
              onSubmit={this.submitForm(this.state.email, this.state.password)}
            >
              <div>
                <TextField
                  fullWidth
                  required
                  margin="normal"
                  type="question"
                  label="Question"
                  name="question"
                  placeholder="Question"
                  value={this.state.question}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <TextField
                  fullWidth
                  required
                  margin="normal"
                  type="answer"
                  name="answer"
                  label="Answer"
                  placeholder="Answer"
                  value={this.state.answer}
                  onChange={this.handleChange}
                />
              </div>

              <Button
                variant="contained"
                type="submit"
                fullWidth
                size="large"
                disabled={this.props.inProgress}
                style={{ boxShadow: "none", marginTop: "20px" }}
              >
                Create Security Question
              </Button>
            </form>
          </div>
        </CardContent>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    user: state.user
  };
}

SecurityQuestion.propTypes = {
  user: PropTypes.object,
  auth: PropTypes.object,
  inProgress: PropTypes.bool,
  history: PropTypes.object,
  isLoggedIn: PropTypes.func,
  updateSnackbar: PropTypes.func,
  fetchUser: PropTypes.func
};

export default connect(mapStateToProps, {
  isLoggedIn,
  updateSnackbar,
  fetchUser
})(SecurityQuestion);
